// TODO (mitesh) Update to an enum?
export type CommonLanguage =
  (typeof COMMON_LANGUAGES)[keyof typeof COMMON_LANGUAGES];

export const COMMON_LANGUAGES = {
  AR: 'ar',
  DA: 'da',
  DE: 'de',
  EN: 'en',
  ES: 'es',
  ET: 'et',
  ES_419: 'es-419',
  FR: 'fr',
  FR_CA: 'fr-CA',
  HE: 'he',
  IT: 'it',
  JA: 'ja',
  KO: 'ko',
  NL: 'nl',
  PL: 'pl',
  PT: 'pt',
  SR_LATN: 'sr-Latn',
  TR: 'tr',
  ZH: 'zh',
  ZH_TW: 'zh-TW',
};

export const LANGUAGE_NAMES = {
  [COMMON_LANGUAGES.AR]: 'Arabic',
  [COMMON_LANGUAGES.DA]: 'Danish',
  [COMMON_LANGUAGES.DE]: 'German',
  [COMMON_LANGUAGES.EN]: 'English',
  [COMMON_LANGUAGES.ES]: 'Spanish - EU',
  [COMMON_LANGUAGES.ES_419]: 'Spanish - Latam',
  [COMMON_LANGUAGES.ET]: 'Estonian',
  [COMMON_LANGUAGES.FR]: 'French',
  [COMMON_LANGUAGES.FR_CA]: 'French - Canada',
  [COMMON_LANGUAGES.HE]: 'Hebrew',
  [COMMON_LANGUAGES.IT]: 'Italian',
  [COMMON_LANGUAGES.JA]: 'Japanese',
  [COMMON_LANGUAGES.KO]: 'Korean',
  [COMMON_LANGUAGES.NL]: 'Dutch',
  [COMMON_LANGUAGES.PL]: 'Polish',
  [COMMON_LANGUAGES.PT]: 'Portuguese',
  [COMMON_LANGUAGES.SR_LATN]: 'Serbian',
  [COMMON_LANGUAGES.TR]: 'Turkish',
  [COMMON_LANGUAGES.ZH]: 'Chinese - Simplified',
  [COMMON_LANGUAGES.ZH_TW]: 'Chinese - Traditional',
};

export const LANGUAGE_NATIVE_NAMES = {
  [COMMON_LANGUAGES.AR]: 'العربية',
  [COMMON_LANGUAGES.DA]: 'Dansk',
  [COMMON_LANGUAGES.DE]: 'Deutsch',
  [COMMON_LANGUAGES.EN]: 'English',
  [COMMON_LANGUAGES.ES]: 'Español (España)',
  [COMMON_LANGUAGES.ES_419]: 'Español (Latinoamerica)',
  [COMMON_LANGUAGES.ET]: 'Eesti keel',
  [COMMON_LANGUAGES.FR]: 'Français',
  [COMMON_LANGUAGES.FR_CA]: 'Français (Canada)',
  [COMMON_LANGUAGES.HE]: 'עִבְרִית',
  [COMMON_LANGUAGES.IT]: 'Italiano',
  [COMMON_LANGUAGES.JA]: '日本語',
  [COMMON_LANGUAGES.KO]: '한국어',
  [COMMON_LANGUAGES.NL]: 'Nederlands',
  [COMMON_LANGUAGES.PL]: 'Polski',
  [COMMON_LANGUAGES.PT]: 'Português',
  [COMMON_LANGUAGES.SR_LATN]: 'Srpski (Latinica)',
  [COMMON_LANGUAGES.TR]: 'Türkçe',
  [COMMON_LANGUAGES.ZH]: '简体中文',
  [COMMON_LANGUAGES.ZH_TW]: '繁體中文',
};
